import React from 'react';
import PropTypes from 'prop-types';

const DropDownIcon = ({ fill, ...rest, ...style }) => (
  <svg
    {...rest}
    viewBox="0 0 8 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ ...style }}
  >
    <path
      d="M7.91836 0.0773555C7.80801 -0.0257852 7.62866 -0.0257852 7.51857 0.0773555L4.00388 3.36876L0.482548 0.0773555C0.372114 -0.0257852 0.192765 -0.0257852 0.0827613 0.0773555C-0.0275871 0.180174 -0.0275871 0.347808 0.0827613 0.451029L3.79696 3.92262C3.85218 3.97415 3.92118 4 3.99681 4C4.06581 4 4.14153 3.97415 4.19675 3.92262L7.9113 0.451029C8.02836 0.347808 8.02836 0.180174 7.91836 0.0773555Z"
      fill={fill}
    />
  </svg>
);

DropDownIcon.propTypes = {
  fill: PropTypes.string,
  style: PropTypes.object,
  rest: PropTypes.object,
};

DropDownIcon.defaultProps = {
  fill: '#727183',
  style: {},
  rest: {},
};

export default DropDownIcon;



// WEBPACK FOOTER //
// ./src/assets/DropDownIcon.jsx